module.exports = __webpack_public_path__ + "img/symbol_9.1c678f56.png";